import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Button, IconButton } from "@mui/material";
import Switch from "@mui/material/Switch";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import { FormattedMessage } from "react-intl";

import { CustomSelect, FormattedDate } from "../../../components/common";
import ConfirmDeleteModal from "../../../components/common/ConfirmDeleteModal";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const useStyles = makeStyles(theme => ({
  td: {
    fontSize: 11,
    paddingTop: 12,
    paddingBottom: 12,
  },
  tdCheckbox: {
    padding: "10px 0px 10px 10px",
  },
  link: {
    color: theme.palette.common.link,
    textTransform: "none",
    padding: 0,
    fontSize: 11,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  action: {
    padding: 5,
  },
  icon: {
    color: theme.palette.common.link,
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 11,
  },
  iconTrash: {
    color: theme.palette.primary.main,
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 11,
  },
  img: {
    width: 20,
    height: 20,
    objectFit: "cover",
    borderRadius: "50%",
    verticalAlign: "middle",
    marginRight: 10,
  },
  removeRow: {
    padding: 3,
    color: theme.palette.secondary.dark,
    marginRight: 0,
    "& svg": {
      width: "17px !important",
      height: "17px !important",
    },
  },
}));

const SiteUsersTableRow = ({
  siteRoleOptions,
  siteUser,  
  setOpenWarningModal,
  handleOpenUserDetails,
  siteRolesRights,
  onRemoveSiteUser,
  onInviteSiteUser,
}) => {
  
  const classes = useStyles();
  const [formValues, setFormValues] = useState(siteUser);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const { canManageSiteRoles, canInviteUsers } =
    siteRolesRights || {};

  const {
    email,
    created,
    contact,
    id,
  } = formValues;

  useEffect(() => {
    if (siteUser) {
      setFormValues(siteUser);
    }
  }, [siteUser]);

  const confirmDelete = (siteId, id) => {
    onRemoveSiteUser(siteId, id);
    setConfirmationModal(false);
  };


  return (
    <TableRow>

      <TableCell className={classes.td}>
        <Button
          className={classes.link}
          onClick={() => handleOpenUserDetails(email)}
        >
          {email}
        </Button>
      </TableCell>
      <TableCell className={classes.td}>{contact}</TableCell>
      <TableCell className={classes.td}><FormattedDate value={created}/></TableCell>

      <TableCell className={classes.td}>
        <IconButton sx={{ color: "#3B873E" }} onClick={n => onInviteSiteUser( id, email) }><ThumbUpIcon /></IconButton>
        <IconButton sx={{ color: "#F44336" }} onClick={n => onRemoveSiteUser(id)}><ThumbDownIcon /></IconButton>
      </TableCell>
      
    </TableRow>
  );
};

SiteUsersTableRow.defaultProps = {
  siteUser: null,
  handleOpenEditUser: null,
  siteRoleOptions: [],
};

SiteUsersTableRow.propTypes = {
  siteRoleOptions: PropTypes.arrayOf({}),
  siteUser: PropTypes.shape({
    avatar: PropTypes.string,
    companyName: PropTypes.string,
    email: PropTypes.string,
    lastLoggedIn: PropTypes.instanceOf(Date),
    name: PropTypes.string,
    paymentLiability: PropTypes.bool,
    siteId: PropTypes.number,
    siteRoleId: PropTypes.number,
    siteRoleName: PropTypes.string,
    userId: PropTypes.number,
  }),
  handleOpenEditUser: PropTypes.func,
  handleOpenUserDetails: PropTypes.func.isRequired,
};

export default SiteUsersTableRow;
